export const GTAX_HOST =
  /(^|\.)gta-x\.io$/.test(window.location.hostname) || window.localStorage.getItem("gtax_host") === "1";

export const gx = (p = "") => (GTAX_HOST ? p || "/" : `/gtax${p}`);
